/**
 * Форма реанимации заявки
 */

import React from 'react';
import { Formik, Form } from 'formik';
import { TextInput } from '../../../components/UI/FormItems';
import { useReviveApplication } from '../../../hooks/useAdmin';
import { validApplicationIdSchema } from '../validation/schemas';

interface ReviveFormValues {
  applicationId: string;
}

/**
 * Компонент формы реанимации заявки
 */
export const ReviveApplicationFormComponent: React.FC = () => {
  const reviveApplicationMutation = useReviveApplication();

  const initialValues: ReviveFormValues = {
    applicationId: '',
  };

  const handleSubmit = async (values: ReviveFormValues, { resetForm }: { resetForm: () => void }) => {
    const id = Number(values.applicationId);
    if (!id) return;

    await reviveApplicationMutation.mutateAsync(id);
    resetForm();
  };

  return (
    <fieldset>
      <Formik
        initialValues={initialValues}
        validationSchema={validApplicationIdSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <div style={{ display: 'table' }}>
              <div style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                Реанимировать заявку по id
              </div>
              <div style={{ marginTop: '20px' }} />

              <TextInput
                label="id Заявки : "
                name="applicationId"
                placeholder="123456"
                style={{ width: '100px' }}
              />

              <button
                className="btn"
                type="submit"
                disabled={reviveApplicationMutation.isPending}
                style={{ marginLeft: '10px' }}
              >
                {reviveApplicationMutation.isPending
                  ? 'Реанимация...'
                  : 'Реанимировать заявку'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </fieldset>
  );
};
